'use client';

import dynamic from 'next/dynamic';

import type { SpartanProductTopNavigationProps } from '@/app/lcv/components/sections/spartan/products/shared/top-navigation/types';

const SpartanProductTopNavigationFrame = dynamic(
  () =>
    import('@/app/lcv/components/sections/spartan/products/shared/top-navigation/frame').then(
      (mod) => mod.SpartanProductTopNavigationFrame
    ),
  { ssr: false }
);

export const SpartanProductTopNavigationClient = (
  props: SpartanProductTopNavigationProps
) => <SpartanProductTopNavigationFrame {...props} />;
